import styles from "../../styles/Layout/LeadManagement/LeadManagementWrapper.module.css";
import React, {useCallback, useContext, useMemo, useRef} from 'react';
import {Title} from "../../components/UI/Custom/Title";
import {Tabs} from "../../pages/Lead/components/LeadManagement/Tabs";
import {Panel} from "../../pages/Lead/components/LeadManagement/Panel";
import {Outlet, useParams} from "react-router-dom";
import {ThemeContext} from "../../context/ThemeContext";
import {LangContext} from "../../context/LangContext";
import {LeadPaginator} from '../../components/Lead/LeadPaginator/LeadPaginator';

const translations = {
    ru: {
        title: "Управление лидом",
    },
    en: {
        title: "Lead Management",
    },
};

export const LeadManagementWrapper = ({ role }) => {
    const { id } = useParams();
    const refreshPanelRef = useRef(null);
    const { langSelected } = useContext(LangContext);
    const { theme } = useContext(ThemeContext);
    const t = translations[langSelected] || translations.ru;

    const currentLeadId = useMemo(() => Number(id || 0), [id]);

    const handleSetRefreshPanel = useCallback((refreshFunction) => {
        refreshPanelRef.current = refreshFunction;
    }, []);

    const refreshPanelData = useCallback(() => {
        if (refreshPanelRef.current) {
            refreshPanelRef.current();
        }
    }, []);

    const containerClass = `${styles.container} ${theme === 'dark' ? styles.darkContainer : ''}`;
    const panelContainerClass = `${styles.panelContainer} ${theme === 'dark' ? styles.darkPanelContainer : ''}`;
    const pageContentClass = `${styles.pageContent} ${theme === 'dark' ? styles.darkPageContent : ''}`;

    return (
        <div className={containerClass}>
            <Title
                h2={t.title}
                activeSpan={false}
                rightAddon={<LeadPaginator currentLeadId={currentLeadId} role={role} />}
            />

            <div className={panelContainerClass}>
                <Panel
                    role={role}
                    currentLeadId={currentLeadId}
                    onRefresh={handleSetRefreshPanel}
                />
            </div>

            <div className={styles.contentWrapper}>
                <div className={styles.sidebar}>
                    <Tabs
                        role={role}
                        id={id}
                    />
                </div>
                <div className={pageContentClass}>
                    <Outlet context={{ refreshPanelData }} />
                </div>
            </div>
        </div>
    );
};
